module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCA5NmE2NCA2NCAwIDAgMSA2NCA2NHY3MDRhNjQgNjQgMCAwIDEtNjQgNjRIMTYwYTY0IDY0IDAgMCAxLTY0LTY0VjE2MGE2NCA2NCAwIDAgMSA2NC02NGg3MDR6TTUxMiAyMjMuOGEzMiAzMiAwIDAgMC0zMS44IDI4LjNMNDgwIDI1NS44djUxMi4zYTMyIDMyIDAgMCAwIDUxLjYgMjUuMmwzLTIuNyAxMzUuOC0xMzUuOGEzMiAzMiAwIDAgMC00Mi4yLTQ3LjlsLTMgMi43TDU0NCA2OTAuN1YyNTUuOGEzMiAzMiAwIDAgMC0zMi0zMnoiIGZpbGw9IiMwIiBwLWlkPSIzMzgxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Descending order-filled.svg
// module id = gvSh
// module chunks = 73